import Box from "@mui/material/Box";

export type WeatherState =
  | { status: "idle" | "loading" }
  | {
      status: "ok";
      tempF: number;
      label: string;
      asOf: string;
    }
  | { status: "error" };

function wmoWeatherLabel(code: number): string {
  const clear = [0, 1];
  const cloudy = [2, 3];
  const fog = [45, 48];
  const drizzle = [51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82];
  const snow = [71, 73, 75, 77, 85, 86];
  const storm = [95, 96, 99];
  if (clear.includes(code)) return "Mainly clear";
  if (cloudy.includes(code)) return "Cloudy";
  if (fog.includes(code)) return "Fog";
  if (drizzle.includes(code)) return "Rain";
  if (snow.includes(code)) return "Snow";
  if (storm.includes(code)) return "Stormy";
  return "Mixed skies";
}

export async function fetchNycWeather(): Promise<{
  tempF: number;
  label: string;
  asOf: string;
}> {
  const fridayStr = "2026-04-24";

  const url = `https://api.open-meteo.com/v1/forecast?latitude=40.7128&longitude=-74.0060&hourly=weathercode,temperature_2m&temperature_unit=fahrenheit&timezone=America%2FNew_York&start_date=${fridayStr}&end_date=${fridayStr}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("weather request failed");
  const data: any = await res.json();

  const hourly = data?.hourly;
  if (!hourly || !Array.isArray(hourly.temperature_2m)) {
    throw new Error("unexpected weather payload");
  }

  // 5pm = index 17 in hourly array (0 = midnight, 17 = 5pm)
  const tempF = Math.round(hourly.temperature_2m[17]);
  const code = typeof hourly.weathercode?.[17] === "number" ? hourly.weathercode[17] : 0;

  return {
    tempF,
    label: wmoWeatherLabel(code),
    asOf: `${fridayStr}T17:00`,
  };
}

function Sep() {
  return (
    <Box component="span" sx={{ opacity: 0.45 }}>
      ·
    </Box>
  );
}

export function WeatherStrip({
  sx,
  weather,
}: {
  sx: Record<string, unknown>;
  weather: WeatherState;
}) {
  switch (weather.status) {
    case "idle":
    case "loading":
      return (
        <Box sx={sx} aria-live="polite">
          NYC weather <Sep /> <strong>…</strong>
        </Box>
      );
    case "error":
      return (
        <Box sx={sx} aria-live="polite">
          NYC weather <Sep /> <strong>unavailable</strong>
        </Box>
      );
    case "ok":
      return (
        <Box sx={sx} aria-live="polite">
          NYC Weather <Sep /> <strong>{weather.tempF}°F</strong>
          <Sep />
          {weather.label}
          <Sep />
          <Box component="span" sx={{ opacity: 0.75 }}>
            {weather.asOf} ET
          </Box>
        </Box>
      );
  }
}

